import { render, staticRenderFns } from "./VehiclesTable.vue?vue&type=template&id=4949192e"
import script from "./VehiclesTable.vue?vue&type=script&lang=js"
export * from "./VehiclesTable.vue?vue&type=script&lang=js"
import style0 from "./VehiclesTable.vue?vue&type=style&index=0&id=4949192e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports